export var IdentificationMode;
(function (IdentificationMode) {
    IdentificationMode["idCard"] = "idCard";
    IdentificationMode["passport"] = "passport";
})(IdentificationMode || (IdentificationMode = {}));
